import {storageData} from "@/assets/js/storage";

export function routerJump() {
  const userInfo = storageData.getUserInfo();
  let path = "";
  switch (userInfo.member_type) {
    case "super":
    case "supFive":
    case "system":
    case "sysFive":
    case "viewer":
    case "viewFive":
      path = "/system/sm";
      break;
    case "organ":
    case "orgFive":
      path = "/organization/training_course_manager";
      break;
    case "teacher":
    case "teaFive":
      path = "/teacher/class";
      break;
    case "student":
    case "stuFive":
      path = "/student/student_index";
      break;
    case "registration":
    case "registrationFive":
      path = "/registrationList";
      break;
    case "expireStudent":
    case "expFive":
      path = "/expireStudent/expire_index";
      break;
    case "dataDisplay":
      path = "/dataDisplay/dd";
      break;
    case "instructorAssistant":
      path = "/instructorAssistant/class";
      break;
  }
  return path;
}
export function evaluationJump() {
  const userInfo = storageData.getUserInfo();
  let path = "";
  switch (userInfo.member_type) {
    case "organ":
    case "orgFive":
      path = "/organization/evaluation_list";
      break;
    case "teacher":
    case "teaFive":
      path = "/teacher/evaluation_list";
      break;
    case "student":
    case "stuFive":
      path = "/student/create_evaluation";
      break;
  }
  return path;
}
